import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api.js";
import { useAuth } from "../lib/auth.js";
import { Card, CardContent } from "../components/ui/card.js";
import { Button } from "../components/ui/button.js";

/** Recipient claim redemption (REQ-1.9): redeem token → wallet. */
export function ClaimPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // token is single-use; guard StrictMode double-run
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing claim token");
      return;
    }
    api
      .redeemClaim(token)
      .then(() => refresh())
      .then(() => navigate("/wallet", { replace: true }))
      .catch(() => setError("This claim link is invalid or has expired."));
  }, [params, navigate, refresh]);

  return (
    <div className="grid h-full place-items-center p-6 text-sm">
      {error ? (
        <Card>
          <CardContent className="p-8">
            <p className="text-destructive">{error}</p>
            <Button asChild variant="link" className="mt-2 px-0">
              <a href="/login">Sign in instead</a>
            </Button>
          </CardContent>
        </Card>
      ) : (
        <p className="text-muted-foreground">Claiming your credential…</p>
      )}
    </div>
  );
}
